export enum MEASURE_UNIT_FACADE_MOMENTUM {
  knm = 'knm',
}

export enum MEASURE_UNIT_FACADE_DEFLECTION {
  mm = 'mm',
}
